import { UnknownAction } from 'redux';
import {
  PayerActionTypes,
  FETCH_PAYERS_REQUEST,
  FETCH_PAYERS_SUCCESS,
  FETCH_PAYERS_FAILURE,
  CREATE_PAYER_REQUEST,
  CREATE_PAYER_SUCCESS,
  CREATE_PAYER_FAILURE,
  UPDATE_PAYER_REQUEST,
  UPDATE_PAYER_SUCCESS,
  UPDATE_PAYER_FAILURE,
  DELETE_PAYER_REQUEST,
  DELETE_PAYER_SUCCESS,
  DELETE_PAYER_FAILURE,
  SET_PAYER_SEARCH_TERM,
  SET_PAYER_CURRENT_PAGE,
} from '../actions/payerActions';
import { PayerData, PaginationData } from '../../services/types';

export interface PayerState {
  payers: PayerData[];
  pagination: PaginationData | null;
  loading: boolean;
  error: string | null;
  searchTerm: string;
  currentPage: number;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
}

const initialState: PayerState = {
  payers: [],
  pagination: null,
  loading: false,
  error: null,
  searchTerm: '',
  currentPage: 1,
  creating: false,
  updating: false,
  deleting: false,
};

const payerReducer = (state = initialState, action: UnknownAction): PayerState => {
  const typedAction = action as PayerActionTypes;
  switch (typedAction.type) {
    case FETCH_PAYERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PAYERS_SUCCESS:
      return {
        ...state,
        loading: false,
        payers: typedAction.payload.payers,
        pagination: typedAction.payload.pagination,
        error: null,
      };

    case FETCH_PAYERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: typedAction.payload,
        payers: [],
      };

    case CREATE_PAYER_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };

    case CREATE_PAYER_SUCCESS:
      return {
        ...state,
        creating: false,
        error: null,
        // Optionally add the new payer to the list
        // payers: [typedAction.payload, ...state.payers],
      };

    case CREATE_PAYER_FAILURE:
      return {
        ...state,
        creating: false,
        error: typedAction.payload,
      };

    case UPDATE_PAYER_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };

    case UPDATE_PAYER_SUCCESS:
      return {
        ...state,
        updating: false,
        error: null,
        // Update the payer in the list - handle both string and number IDs
        payers: state.payers.map(payer =>
          String(payer.id) === String(typedAction.payload.id) ? typedAction.payload : payer
        ),
      };

    case UPDATE_PAYER_FAILURE:
      return {
        ...state,
        updating: false,
        error: typedAction.payload,
      };

    case DELETE_PAYER_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
      };

    case DELETE_PAYER_SUCCESS:
      return {
        ...state,
        deleting: false,
        error: null,
        // Remove the payer from the list - handle both string and number IDs
        payers: state.payers.filter(payer => String(payer.id) !== String(typedAction.payload)),
      };

    case DELETE_PAYER_FAILURE:
      return {
        ...state,
        deleting: false,
        error: typedAction.payload,
      };

    case SET_PAYER_SEARCH_TERM:
      return {
        ...state,
        searchTerm: typedAction.payload,
        currentPage: 1, // Reset to first page when searching
      };

    case SET_PAYER_CURRENT_PAGE:
      return {
        ...state,
        currentPage: typedAction.payload,
      };

    default:
      return state;
  }
};

export default payerReducer;

